import React, { memo, Suspense } from 'react'

import About from '@/components/About/About'
import Navigation from '@/components/Navigation/Navigation'

interface Props {}

const AboutPage: React.FC<Props> = memo(() => {
  return (
    <>
      <About />
    </>
  )
})
AboutPage.displayName = 'AboutPage'

export default AboutPage
